import _ from 'lodash'

const PRINTABLE_TYPE_ENTITY_ID = '5209a80d-d216-4a27-acd3-56da546141a5'

export function isPrintable(entity){
  return _.find(entity.activeMixins, (mixin: any) => {
    return mixin.entityId === PRINTABLE_TYPE_ENTITY_ID
  })
}